import styles from './styles/MissingInfoModule.module.scss';
import MissingInfo from 'images/icons/missing-info.png';
import { ReactNode } from 'react';
import ContentSection from '@/components/ContentSection';
import Image from 'components/Image';

export default function MissingInfoModule({
  title = 'No one has submitted this information yet!',
  children = (
    <>
      <p>
        We haven’t received this information yet. If you are the coach, you can submit a request to claim this team and update the schedule,
        roster, stats and more.
      </p>
      {/*<p>
        If you aren’t the coach but would like this page to be updated, learn more about how you can help below or use this link to send us
        the information.
      </p>*/}
    </>
  )
}: {
  title?: string;
  children?: ReactNode;
}) {
  return (
    <ContentSection>
      <div className={styles.Container}>
        <div className={styles.Image}>
          <Image src={MissingInfo} />
        </div>
        <div className={styles.Text}>
          <div className={styles.Header}>{title}</div>
          {children}
        </div>
      </div>
    </ContentSection>
  );
}
